/**
 * GM Store Locator — upgrade-safe custom asset.
 * Data: gm-store-locations.json
 * Map: Google Maps JS when data-maps-key / window.gmStoreLocatorMapsKey set.
 */
(function () {
  'use strict';

  function $(root, sel) {
    return root.querySelector(sel);
  }

  function toRad(d) {
    return (d * Math.PI) / 180;
  }

  function haversine(lat1, lng1, lat2, lng2, unit) {
    var R = unit === 'km' ? 6371 : 3958.7613;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /** Multi-line address parts (no name/phone): street, city/region/zip, country */
  function addressLines(s) {
    var lines = [];
    if (s.address1) lines.push(s.address1);
    if (s.address2) lines.push(s.address2);
    var cityLine = [s.city, s.region, s.zip].filter(Boolean).join(', ');
    if (cityLine) lines.push(cityLine);
    if (s.country) lines.push(s.country);
    return lines;
  }

  function formatAddress(s) {
    return addressLines(s).join('\n');
  }

  function directionsUrl(s) {
    var q = encodeURIComponent(
      [s.address1, s.city, s.region, s.zip, s.country].filter(Boolean).join(', ')
    );
    return 'https://www.google.com/maps/dir/?api=1&destination=' + q;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function decodeHtmlEntities(str) {
    if (str == null || typeof str !== 'string' || str.indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  function cleanStore(s) {
    var o = Object.assign({}, s);
    ['name', 'address1', 'address2', 'city', 'region', 'zip', 'country', 'phone', 'website'].forEach(function (k) {
      if (typeof o[k] === 'string') o[k] = decodeHtmlEntities(o[k]);
    });
    return o;
  }

  function isGmShowroom(s) {
    var n = (s && s.name) || '';
    return /^gaynor\s+minden\s+showroom$/i.test(n.trim());
  }


  var GM_PIN_PINK = '#D42A6A';
  var GM_PIN_CHARCOAL = '#1C1C1C';

  function pinColorForStore(s) {
    // Preferred, Featured, or Preferred+Brown Satin → pink; else charcoal
    if (s.preferred || s.featured) return GM_PIN_PINK;
    return GM_PIN_CHARCOAL;
  }

  function pinIcon(color) {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="40" viewBox="0 0 28 40">' +
      '<path fill="' +
      color +
      '" stroke="#ffffff" stroke-width="1.25" d="M14 1.2C7.04 1.2 1.4 6.84 1.4 13.8c0 8.9 10.2 18.9 12.05 20.55a.9.9 0 0 0 1.1 0C16.4 32.7 26.6 22.7 26.6 13.8 26.6 6.84 20.96 1.2 14 1.2z"/>' +
      '<circle fill="#ffffff" cx="14" cy="13.8" r="4.2"/>' +
      '</svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: { width: 28, height: 40 },
      anchor: { x: 14, y: 40 },
    };
  }


  function loadGoogleMaps(key) {
    if (window.google && window.google.maps) {
      return Promise.resolve();
    }
    if (window.__gmMapsLoading) return window.__gmMapsLoading;
    window.__gmMapsLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(key) +
        '&libraries=places&v=weekly';
      s.async = true;
      s.onload = function () {
        resolve();
      };
      s.onerror = function () {
        reject(new Error('Google Maps failed to load'));
      };
      document.head.appendChild(s);
    });
    return window.__gmMapsLoading;
  }

  function initRoot(root) {
    var jsonUrl = root.getAttribute('data-json-url');
    var mapsKey =
      root.getAttribute('data-maps-key') || window.gmStoreLocatorMapsKey || '';
    var unit = root.getAttribute('data-unit') || 'mi';
    var startLat = parseFloat(root.getAttribute('data-start-lat') || '40.712775');
    var startLng = parseFloat(root.getAttribute('data-start-lng') || '-74.005973');

    var listEl = $(root, '[data-gm-sl-list]');
    var statusEl = $(root, '[data-gm-sl-status]');
    var mapEl = $(root, '[data-gm-sl-map]');
    var locationInput = $(root, '[data-gm-sl-location]');
    var radiusSel = $(root, '[data-gm-sl-radius]');
    var resultsSel = $(root, '[data-gm-sl-results]');
    var searchBtn = $(root, '[data-gm-sl-search]');
    var geoBtn = $(root, '[data-gm-sl-geo]');

    var allStores = [];
    var origin = { lat: startLat, lng: startLng, label: '' };
    var map = null;
    var markers = [];
    var infoWindow = null;
    var autocomplete = null;

    function setStatus(msg) {
      if (statusEl) statusEl.textContent = msg || '';
    }

    function clearMarkers() {
      markers.forEach(function (m) {
        m.setMap(null);
      });
      markers = [];
    }

    function ensureMap() {
      if (!mapsKey || !mapEl) return Promise.resolve(false);
      return loadGoogleMaps(mapsKey)
        .then(function () {
          if (!map) {
            map = new google.maps.Map(mapEl, {
              center: { lat: origin.lat, lng: origin.lng },
              zoom: 4,
              mapTypeControl: false,
              streetViewControl: false,
              fullscreenControl: false,
            });
            infoWindow = new google.maps.InfoWindow();
            if (locationInput && google.maps.places) {
              autocomplete = new google.maps.places.Autocomplete(locationInput, {
                fields: ['geometry', 'formatted_address', 'name'],
                types: ['(regions)'],
              });
              autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();
                if (place && place.geometry && place.geometry.location) {
                  origin = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    label: place.formatted_address || place.name || '',
                  };
                  runSearch();
                }
              });
            }
          }
          return true;
        })
        .catch(function () {
          if (mapEl && !mapEl.querySelector('.gm-store-locator__map-fallback')) {
            mapEl.innerHTML =
              '<div class="gm-store-locator__map-fallback">Map could not load. Check the Google Maps API key.</div>';
          }
          return false;
        });
    }

    function renderList(results) {
      listEl.innerHTML = '';
      if (!results.length) {
        setStatus('No stores found. Try a larger radius or clear filters.');
        return;
      }
      setStatus(results.length + ' store' + (results.length === 1 ? '' : 's') + ' found');
      results.forEach(function (s, idx) {
        var li = document.createElement('li');
        li.className = 'gm-store-locator__item';
        li.setAttribute('data-index', String(idx));

        var badges = '';
        // Showroom is GM-owned — do not label as Preferred Retailer
        if (s.preferred && !isGmShowroom(s)) {
          badges += '<span class="gm-store-locator__badge">Preferred Retailer</span>';
        }
        if (s.brown_satin) badges += '<span class="gm-store-locator__badge">Brown Satin Partner</span>';
        if (s.featured) badges += '<span class="gm-store-locator__badge">Featured</span>';

        var linesHtml = addressLines(s)
          .map(function (line) {
            return '<span class="gm-store-locator__item-line"></span>';
          })
          .join('');

        var phoneHtml = s.phone
          ? '<span class="gm-store-locator__item-line gm-store-locator__item-phone"><a href="tel:' +
            escapeHtml(s.phone.replace(/[^\d+]/g, '')) +
            '"></a></span>'
          : '';

        var dir =
          '<a href="' +
          directionsUrl(s) +
          '" target="_blank" rel="noopener">Directions</a>';
        var web = s.website
          ? '<a href="' + escapeHtml(s.website) + '" target="_blank" rel="noopener">Website</a>'
          : '';

        // Order: name, address/phone, Directions, then badges (no distance)
        li.innerHTML =
          '<p class="gm-store-locator__item-name"></p>' +
          '<div class="gm-store-locator__item-address">' +
          linesHtml +
          phoneHtml +
          '</div>' +
          '<div class="gm-store-locator__item-links">' +
          dir +
          (web || '') +
          '</div>' +
          (badges ? '<div class="gm-store-locator__badges">' + badges + '</div>' : '');

        li.querySelector('.gm-store-locator__item-name').textContent = s.name || '';

        var lineEls = li.querySelectorAll(
          '.gm-store-locator__item-address > .gm-store-locator__item-line:not(.gm-store-locator__item-phone)'
        );
        addressLines(s).forEach(function (line, i) {
          if (lineEls[i]) lineEls[i].textContent = line;
        });

        if (s.phone) {
          var phoneA = li.querySelector('.gm-store-locator__item-phone a');
          if (phoneA) phoneA.textContent = s.phone;
        }

        li.addEventListener('click', function (ev) {
          if (ev.target.closest('a')) return;
          listEl.querySelectorAll('.gm-store-locator__item').forEach(function (el) {
            el.classList.remove('is-active');
          });
          li.classList.add('is-active');
          if (map && markers[idx]) {
            map.panTo(markers[idx].getPosition());
            map.setZoom(Math.max(map.getZoom(), 12));
            google.maps.event.trigger(markers[idx], 'click');
          }
        });

        listEl.appendChild(li);
      });
    }

    function renderMap(results) {
      if (!map) return;
      clearMarkers();
      var bounds = new google.maps.LatLngBounds();
      bounds.extend({ lat: origin.lat, lng: origin.lng });

      results.forEach(function (s) {
        var pos = { lat: s.lat, lng: s.lng };
        var icon = pinIcon(pinColorForStore(s));
        var marker = new google.maps.Marker({
          map: map,
          position: pos,
          title: s.name,
          icon: {
            url: icon.url,
            scaledSize: new google.maps.Size(icon.scaledSize.width, icon.scaledSize.height),
            anchor: new google.maps.Point(icon.anchor.x, icon.anchor.y),
          },
        });
        marker.addListener('click', function () {
          var addr = formatAddress(s).replace(/\n/g, '<br>');
          infoWindow.setContent(
            '<strong>' +
              escapeHtml(s.name) +
              '</strong><br>' +
              addr +
              (s.phone ? '<br>' + escapeHtml(s.phone) : '') +
              '<br><a href="' +
              directionsUrl(s) +
              '" target="_blank" rel="noopener">Directions</a>'
          );
          infoWindow.open(map, marker);
        });
        markers.push(marker);
        bounds.extend(pos);
      });

      if (results.length) {
        map.fitBounds(bounds, 48);
      } else {
        map.setCenter({ lat: origin.lat, lng: origin.lng });
        map.setZoom(4);
      }
    }

    function activeFilters() {
      var f = { preferred: false, brown_satin: false };
      root.querySelectorAll('[data-gm-sl-filter]').forEach(function (el) {
        if (el.checked) f[el.getAttribute('data-gm-sl-filter')] = true;
      });
      return f;
    }

    function runSearch() {
      var radius = parseFloat(radiusSel.value) || 50;
      var maxResults = parseInt(resultsSel.value, 10) || 25;
      var filters = activeFilters();

      var results = allStores
        .filter(function (s) {
          if (filters.preferred && !s.preferred) return false;
          if (filters.brown_satin && !s.brown_satin) return false;
          return true;
        })
        .map(function (s) {
          var d = haversine(origin.lat, origin.lng, s.lat, s.lng, unit);
          return Object.assign({}, s, { distance: d });
        })
        .filter(function (s) {
          return s.distance <= radius;
        })
        .sort(function (a, b) {
          return a.distance - b.distance;
        })
        .slice(0, maxResults);

      renderList(results);
      ensureMap().then(function (ok) {
        if (ok) renderMap(results);
      });
    }

    function geocodeText(text) {
      if (!mapsKey) {
        setStatus('Add a Google Maps API key in the section settings to search by city/zip (or use location button).');
        return Promise.reject();
      }
      return ensureMap().then(function (ok) {
        if (!ok || !window.google || !google.maps) return Promise.reject();
        return new Promise(function (resolve, reject) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: text }, function (results, status) {
            if (status === 'OK' && results && results[0]) {
              var loc = results[0].geometry.location;
              origin = {
                lat: loc.lat(),
                lng: loc.lng(),
                label: results[0].formatted_address || text,
              };
              resolve();
            } else {
              reject(new Error(status || 'not found'));
            }
          });
        });
      });
    }

    searchBtn.addEventListener('click', function () {
      var text = (locationInput.value || '').trim();
      if (text) {
        ensureMap()
          .then(function () {
            return geocodeText(text);
          })
          .then(runSearch)
          .catch(function () {
            setStatus('Could not find that location. Try city, state, or zip.');
          });
      } else {
        runSearch();
      }
    });

    locationInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchBtn.click();
      }
    });

    if (geoBtn) {
      geoBtn.addEventListener('click', function () {
        if (!navigator.geolocation) {
          setStatus('Geolocation is not available in this browser.');
          return;
        }
        setStatus('Getting your location…');
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            origin = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
              label: 'Your location',
            };
            locationInput.value = 'Your location';
            runSearch();
          },
          function () {
            setStatus('Could not access your location.');
          },
          { enableHighAccuracy: false, timeout: 10000 }
        );
      });
    }

    setStatus('Loading stores…');
    fetch(jsonUrl, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('json ' + r.status);
        return r.json();
      })
      .then(function (data) {
        allStores = (Array.isArray(data) ? data : []).map(cleanStore);
        setStatus(allStores.length + ' stores loaded. Search or use your location.');
        // Initial: show nearest to default center without requiring click
        runSearch();
      })
      .catch(function () {
        setStatus('Could not load store data.');
      });
  }

  function boot() {
    document.querySelectorAll('[data-gm-store-locator]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
